// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__fWrbM","modalForm":"UpgradeEpcsModal_modalForm__1r7zm","modalFooter":"UpgradeEpcsModal_modalFooter__1cIjI"};